import { Injectable } from '@angular/core';

import { CamBaseService, GraphEndpoint, HandleSimpleRequest } from '@camelot/server';

import {
  CalendarSyncConfiguration,
  CalendarSyncConfigurationCreationPayloadInput,
  CalendarSyncConfigurationModifierPayloadInput,
  calendarSyncConfigurationProps,
} from './dto/calendar-sync-config';
import { CREATE_CALENDAR_SYNC_CONFIG, UPDATE_CALENDAR_SYNC_CONFIG } from './mutations';
import { GET_CALENDAR_SYNC_CONFIG } from './queries';

const graphEndpoint: GraphEndpoint = {
  clientName: 'planningService',
  endpoint: 'planning',
};

@Injectable({
  providedIn: 'root',
})
export class CamCalendarSyncConfigsService extends CamBaseService {
  protected _graphEndpoint = graphEndpoint;
  public calendarSyncConfiguration = new HandleSimpleRequest<CalendarSyncConfiguration>();

  constructor() {
    super();
    super.registerRoutes({ graphEndpoint: graphEndpoint });
  }

  public fetchCalendarSyncConfiguration$() {
    return this.calendarSyncConfiguration.fetch(
      this._graphService.fetchQuery<CalendarSyncConfiguration>(
        GET_CALENDAR_SYNC_CONFIG(
          `
            ${calendarSyncConfigurationProps.get('id')}
            ${calendarSyncConfigurationProps.get('clientId')}
            ${calendarSyncConfigurationProps.get('clientSecret')}
            ${calendarSyncConfigurationProps.get('clientTenantId')}
          `
        ),
        'calendSyncConfiguration',
        graphEndpoint.clientName
      )
    );
  }

  public createCalendarSyncConfig$(calendarSyncConfig: CalendarSyncConfigurationCreationPayloadInput) {
    return this._graphService.mutateBuilder<CalendarSyncConfiguration>(
      CREATE_CALENDAR_SYNC_CONFIG(calendarSyncConfig),
      graphEndpoint.clientName,
      ['calendarSyncConfiguration']
    );
  }
  public updateCalendarSyncConfig$(calendarSyncConfig: Partial<CalendarSyncConfigurationModifierPayloadInput>) {
    return this._graphService.mutateBuilder<CalendarSyncConfiguration>(
      UPDATE_CALENDAR_SYNC_CONFIG(calendarSyncConfig),
      graphEndpoint.clientName,
      ['calendarSyncConfiguration']
    );
  }
}
